import { render, staticRenderFns } from "./DonatorInfoDetail.vue?vue&type=template&id=2f48611d&scoped=true&"
import script from "./DonatorInfoDetail.vue?vue&type=script&lang=js&"
export * from "./DonatorInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./DonatorInfoDetail.vue?vue&type=style&index=0&id=2f48611d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48611d",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QAvatar});qInstall(component, 'directives', {ClosePopup});
